/**
 * Thin customer wrapper over shared createClientLogger.
 */

import {
  createClientLogger,
  getClientCorrelationId,
  type ClientLoggerMeta,
} from 'pi-kiosk-shared/logging';

export type CustomerLoggerMeta = ClientLoggerMeta;

function readVersion(): string | undefined {
  try {
    const v = import.meta.env.VITE_BUILD_VERSION;
    if (typeof v === 'string' && v.trim().length > 0) {
      return v.trim();
    }
  } catch {
    // non-Vite contexts
  }
  return undefined;
}

export const customerLogger = createClientLogger({
  app: 'rpapp-customer',
  getCorrelationId: getClientCorrelationId,
  readVersion,
});
